import { motion } from "framer-motion";
import Reveal, { EASE, Eyebrow } from "./Reveal";
import { Wash, Sprig } from "./Watercolor";

const WATERCOLOR_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_custom-umbrellas/artifacts/4a6d11a106984c4f_493916EC-1780-470C-87C1-171EC2759233.png";

export default function MeetElla({ onNavigate }) {
  return (
    <section id="ella" className="relative py-24 sm:py-28 bg-creamdeep" data-testid="ella-section">
      <Wash color="#F472B6" size={460} opacity={0.22} className="top-8 -right-36" />
      <Sprig color="#F472B6" className="hidden lg:block -bottom-4 left-[5%] w-28" />
      <Sprig color="#FFD166" flip className="hidden lg:block top-10 right-[7%] w-24" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid gap-12 lg:gap-16 lg:grid-cols-12 items-center">
        <Reveal className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, y: 24, rotate: -4 }}
            whileInView={{ opacity: 1, y: 0, rotate: -2 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="relative rounded-xl bg-white p-3 pb-4 shadow-2xl shadow-moss/20"
            data-testid="ella-dex-watercolor"
          >
            <img
              src={WATERCOLOR_IMG}
              alt="Watercolour painting of Ella and Dex laughing together in their kitchen"
              loading="lazy"
              className="w-full rounded-md"
              data-testid="ella-dex-watercolor-image"
            />
            <p className="pt-3 text-center font-serif italic text-ink/70" data-testid="ella-dex-watercolor-caption">
              Ella &amp; Dex — where it all began
            </p>
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-marigold px-5 py-2.5 shadow-lg">
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink" data-testid="ella-badge">
                Artist · Teacher · Lover at heart
              </span>
            </div>
          </motion.div>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.1}>
          <Eyebrow>Meet Ella</Eyebrow>
          <h2 className="mt-4 font-serif font-medium tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl">
            Welcome! I'm Ella.
          </h2>
          <div className="mt-6 space-y-4 max-w-xl text-ink/70 leading-relaxed" data-testid="ella-bio">
            <p>
              I'm happy to be your artist today! Painting pretty parasols has not always been
              my thing — in my previous life I was a school teacher and a human rights
              activist. And of course, I'm a lover at heart.
            </p>
            <p>
              I started Ella's Umbrellas when my husband Dex was diagnosed with an aggressive
              illness that affects his mental capacities. I needed something to make a little
              extra money, and to keep myself busy during the often long days at home caring
              for him.
            </p>
            <p>
              I have more umbrellas already painted — if you'd like to see more photos, drop
              me a line. And for the same cost, you can tell me your own ideas for a custom
              canopy. Thanks for looking!
            </p>
          </div>

          <blockquote className="mt-8 border-l-4 border-terracotta pl-6" data-testid="ella-quote">
            <p className="font-serif italic text-2xl sm:text-3xl tracking-tight text-ink max-w-md">
              "Painting flowers is what I am good at, but I will try to paint anything you want."
            </p>
            <cite className="mt-3 block font-serif italic text-3xl text-terracotta not-italic">Ella</cite>
          </blockquote>

          <div className="mt-8 flex flex-wrap gap-4">
            <button
              data-testid="ella-cta-order"
              onClick={() => onNavigate("#order")}
              className="rounded-full bg-terracotta px-7 py-3.5 font-semibold text-white shadow-xl shadow-terracotta/25 transition-all hover:bg-terracotta/90 hover:-translate-y-0.5"
            >
              Drop me a line — order yours
            </button>
            <button
              data-testid="ella-cta-collection"
              onClick={() => onNavigate("#collection")}
              className="rounded-full border-2 border-ink/15 bg-white/70 px-6 py-3 font-semibold text-ink transition-colors hover:border-terracotta hover:text-terracotta"
            >
              See the collection
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
